import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { PickrightControlModule } from '@shared/form-control/form-control.module';
import { AppLoaderModule } from '@shared/loader/loader.module';
import { ButtonModule } from '@shared/button/button.module';



@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: '', component: LoginComponent }
    ]),
    ReactiveFormsModule,
    PickrightControlModule,
    AppLoaderModule,
    ButtonModule
  ]
})
export class LoginModule { }
